<template>
  <v-container
      fluid
  >

    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>

          <v-btn
            class="btn-shortcut"
            elevation="2"
            @click="$router.push({ name: 'patients' })"
          >
            <v-icon>mdi-account-details</v-icon>
            {{ $t('Patients') }}
          </v-btn>


          <v-btn
            class="btn-shortcut"
            elevation="2"
            @click="$router.push({ name: 'stock' })"
          >
            <v-icon>mdi-playlist-check</v-icon>
            {{ $t('Pharmacy') }}
          </v-btn>

        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <h4>{{ $t('Latest patient information') }}</h4>

          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :no-results-text="$t('No matching data found')"
            :no-data-text="$t('No data available')"
            :hide-default-footer="true"
            @click:row="toPatient"
          >
            <template v-slot:item.birth_date="{ item }">
              <span>{{ myFormatDate(item.birth_date) }}</span>
            </template>

            <template v-slot:item.status_since="{ item }">
              <span>{{ myFormatDate(item.status_since) }}</span>
            </template>

            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                </v-col>
                <v-col cols="6" class="text-right">
                </v-col>
              </v-row>
            </template>
          </v-data-table>

        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
//import SessionService from '@/services/session.service'
import _ from 'lodash'
import { DateTime, formatDate } from '@/lib/helpers'

export default {
  data: () => ({
    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: -1,
    },
    //search: '',
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('Name'), value: 'full_name', align: 'left', sortable: true, width: '12%' },
        { text: this.$t('Date of birth'), value: 'birth_date', align: 'left', sortable: true, width: '12%' },
        { text: this.$t('Municipality'), value: 'municipality', align: 'left', sortable: true, width: '20%' },
        { text: this.$t('Village or town'), value: 'village_or_town', align: 'left', sortable: true, width: '20%' },
        { text: this.$t('Province'), value: 'province', align: 'left', sortable: true, width: '12%' },
        { text: this.$t('Completion date'), value: 'status_since', align: 'left', sortable: true, width: '12%' },
        { text: this.$t('Finished module'), value: 'finished_module', align: 'left', sortable: true, width: '12%' },
      ]
    },
  },
  watch: {
    '$i18n.locale': function () {
        this.fetchItems()
    },
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
  },
  methods: {
    fetchItems: _.debounce(function() {
      this.loading = true
      //this.saveFilters()
      ApiService.index('/appointments-meta', this.options, {
        params: {
          filter: {
            //query: this.search,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
/*
    saveFilters() {
      SessionService.setItem('filter_appointments_meta', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_appointments_meta')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
*/
    toPatient(item) {
      this.$router.push({
        name: 'patient',
        params: {
          patientId: item.patient_id,
        },
      })
    },
    myFormatDate(isoDate) {
      return formatDate(DateTime.fromISO(isoDate))
    },
  },
  created() {
    this.$store.dispatch('session/title', 'Dashboard')
  },
}
</script>

<style scoped>
.btn-shortcut {
    width: 200px;
    margin-right: 20px;
}
.btn-shortcut i {
    margin-right: 0.3em;
}
</style>

